import { IValidation } from "./";

const Validation: IValidation = {
  error: "Por favor, digite um email válido",
  validate: (input: string) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(input),
};

export default Validation;
